// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvoiceStatusType } from './IInvoiceStatusType';
import {
    IInvoiceStatusTypeFromJSON,
    IInvoiceStatusTypeFromJSONTyped,
    IInvoiceStatusTypeToJSON,
    IInvoiceStatusTypeToJSONTyped,
} from './IInvoiceStatusType';

/**
 * 
 * @export
 * @interface IContributionRecordGroupInfoAggregateDto
 */
export interface IContributionRecordGroupInfoAggregateDto {
    /**
     * 
     * @type {number}
     * @memberof IContributionRecordGroupInfoAggregateDto
     */
    ee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IContributionRecordGroupInfoAggregateDto
     */
    er_contribution_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordGroupInfoAggregateDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordGroupInfoAggregateDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IContributionRecordGroupInfoAggregateDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {IInvoiceStatusType}
     * @memberof IContributionRecordGroupInfoAggregateDto
     */
    invoice_status_type?: IInvoiceStatusType;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordGroupInfoAggregateDto
     */
    contribution_request_status?: IContributionRecordGroupInfoAggregateDtoContributionRequestStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IContributionRecordGroupInfoAggregateDtoContributionRequestStatusEnum {
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
    ERROR = 'ERROR',
    VALIDATION_FAILED = 'VALIDATION_FAILED',
    APPROVAL_NEEDED = 'APPROVAL_NEEDED',
    REJECTED = 'REJECTED',
    SUBMITTED = 'SUBMITTED'
}


/**
 * Check if a given object implements the IContributionRecordGroupInfoAggregateDto interface.
 */
export function instanceOfIContributionRecordGroupInfoAggregateDto(value: object): value is IContributionRecordGroupInfoAggregateDto {
    return true;
}

export function IContributionRecordGroupInfoAggregateDtoFromJSON(json: any): IContributionRecordGroupInfoAggregateDto {
    return IContributionRecordGroupInfoAggregateDtoFromJSONTyped(json, false);
}

export function IContributionRecordGroupInfoAggregateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionRecordGroupInfoAggregateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ee_contribution_amount': json['ee_contribution_amount'] == null ? undefined : json['ee_contribution_amount'],
        'er_contribution_amount': json['er_contribution_amount'] == null ? undefined : json['er_contribution_amount'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'invoice_status_type': json['invoice_status_type'] == null ? undefined : IInvoiceStatusTypeFromJSON(json['invoice_status_type']),
        'contribution_request_status': json['contribution_request_status'] == null ? undefined : json['contribution_request_status'],
    };
}

export function IContributionRecordGroupInfoAggregateDtoToJSON(json: any): IContributionRecordGroupInfoAggregateDto {
    return IContributionRecordGroupInfoAggregateDtoToJSONTyped(json, false);
}

export function IContributionRecordGroupInfoAggregateDtoToJSONTyped(value?: IContributionRecordGroupInfoAggregateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ee_contribution_amount': value['ee_contribution_amount'],
        'er_contribution_amount': value['er_contribution_amount'],
        'plan_code': value['plan_code'],
        'plan_name': value['plan_name'],
        'invoice_id': value['invoice_id'],
        'invoice_status_type': IInvoiceStatusTypeToJSON(value['invoice_status_type']),
        'contribution_request_status': value['contribution_request_status'],
    };
}

